<template>
  <div class="box-container overflow-y-scroll width100 height100">
    <v-row class="m-r-0 m-l-0">
      <v-col cols="12" sm="4" md="4" lg="4">
        <pie-valid-speech :color="colorSpeech" :data="pieValidSpeech" />
      </v-col>
      <v-col cols="12" sm="8" md="8" lg="8">
        <bar-word-accuracy
          :title="wordAccuracyTitle"
          :xAxis1="chartWordAccuracyXAxis1"
          :data1="chartWordAccuracyData1"
          :data2="chartWordAccuracyData2"
          :data3="chartWordAccuracyData3"
          :totalPercent="wordAccuracyTotalPercent"
        />
      </v-col>
    </v-row>

    <v-row class="m-r-0 m-l-0">
      <v-col cols="12" sm="12" md="12" lg="12">
        <bar-word-accuracy
          :title="intentAccuracyTitle"
          :xAxis1="chartIntentAccuracyXAxis1"
          :data1="chartIntentAccuracyData1"
          :data2="chartIntentAccuracyData2"
          :data3="chartIntentAccuracyData3"
          :totalPercent="intentAccuracyTotalPercent"
        />
      </v-col>
    </v-row>

    <v-row class="m-r-0 m-l-0">
      <v-col cols="12" sm="6" md="6" lg="6">
        <div class="m-b-25">
          <table-data
            :loading="loading"
            :headers1="headersSamplingScope.headers1"
            :headers2="headersSamplingScope.headers2"
            :data="tableSamplingScope"
            :total="tableSamplingScopeTotal"
            :totalPercent="tableSamplingScopeTotalPercent"
          />
        </div>
        <div class="m-b-25">
          <table-data
            :loading="loading"
            :headers1="headersValidSpeech.headers1"
            :headers2="headersValidSpeech.headers2"
            :data="tableValidSpeech"
            :total="tableValidSpeechTotal"
            :totalPercent="tableValidSpeechTotalPercent"
          />
        </div>
        <div class="m-b-25">
          <table-data
            :loading="loading"
            :headers1="headersWordAccuracy.headers1"
            :headers2="headersWordAccuracy.headers2"
            :data="tableWordAccuracy"
            :total="wordAccuracyTotal"
            :totalPercent="wordAccuracyTotalPercent"
          />
        </div>
        <div>
          <table-data
            :loading="loading"
            :headers1="headersQcPersons.headers1"
            :headers2="headersQcPersons.headers2"
            :data="tableQcPersons"
            :total="tableQcPersonsTotal"
            :totalPercent="tableQcPersonsTotalPercent"
          />
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <table-data
          :loading="loading"
          :headers1="headersIntentAccuracy.headers1"
          :headers2="headersIntentAccuracy.headers2"
          :data="tableIntentAccuracy"
          :total="intentAccuracyTotal"
          :totalPercent="intentAccuracyTotalPercent"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import apiInsight from '@/apis/insight'

import PieValidSpeech from './pie_valid_speech'
import BarWordAccuracy from './bar_word_accuracy'
import TableData from './table_data'

import headersSamplingScope from './headers/headers_sampling_scope.json'
import headersValidSpeech from './headers/headers_valid_speech.json'
import headersWordAccuracy from './headers/headers_word_accuracy.json'
import headersQcPersons from './headers/headers_qc_persons.json'
import headersIntentAccuracy from './headers/headers_intent_accuracy.json'

export default {
  props: {
    search: Object,
    count: Number,
    checkTotalQc: Function
  },
  components: {
    PieValidSpeech,
    BarWordAccuracy,
    TableData
  },
  data() {
    return {
      // Pie valid speech
      colorSpeech: [],
      pieValidSpeech: [],

      // Word accuracy
      wordAccuracyTitle: 'Word accuracy',
      wordAccuracyTotal: 0,
      wordAccuracyTotalPercent: 0,
      // Chart
      chartWordAccuracyXAxis1: {
        type: 'category',
        boundaryGap: true,
        data: [],
        axisTick: {
          show: false
        },
        axisLabel: {
          intervel: 0,
          overflow: 'truncate',
          width: 100,
          rotate: 35
        }
      },
      chartWordAccuracyData1: {
        name: 'Count',
        type: 'bar',
        label: {
          show: true,
          position: 'inside',
          formatter: params => {
            return `${params.value.toLocaleString()}`
          }
        },
        data: []
      },
      chartWordAccuracyData2: {
        name: 'Word accuracy by grammar',
        type: 'line',
        symbol: 'circle',
        symbolSize: 9,
        lineStyle: {
          width: 0
        },
        yAxisIndex: 1,
        label: {
          show: true,
          textStyle: {
            color: this.$getChatColor[0]
          },
          formatter: params => {
            return `${params.value.toFixed(2)}%`
          }
        },
        data: []
      },
      chartWordAccuracyData3: {
        name: 'Overall word accuracy',
        data: []
      },
      // Table
      headersWordAccuracy,
      tableWordAccuracy: [],

      // Intent accuracy
      intentAccuracyTitle: 'Intent accuracy',
      intentAccuracyTotal: 0,
      intentAccuracyTotalPercent: 0,
      // Chart
      chartIntentAccuracyXAxis1: {
        type: 'category',
        boundaryGap: true,
        data: [],
        axisTick: {
          show: false
        },
        axisLabel: {
          intervel: 0,
          overflow: 'truncate',
          width: 100,
          rotate: 35
        }
      },
      chartIntentAccuracyData1: {
        name: 'Count',
        type: 'bar',
        label: {
          show: true,
          position: 'inside',
          formatter: params => {
            return `${params.value.toLocaleString()}`
          }
        },
        data: []
      },
      chartIntentAccuracyData2: {
        name: 'Intent accuracy',
        type: 'line',
        symbol: 'circle',
        symbolSize: 9,
        lineStyle: {
          normal: {
            width: 0
          }
        },
        yAxisIndex: 1,
        label: {
          show: true,
          textStyle: {
            color: this.$getChatColor[0]
          },
          formatter: params => {
            return `${params.value.toFixed(2)}%`
          }
        },
        data: []
      },
      chartIntentAccuracyData3: {
        name: 'Overall accuracy',
        data: []
      },
      // Table
      headersIntentAccuracy,
      tableIntentAccuracy: [],

      loading: false,

      // Table sampling scope
      headersSamplingScope,
      tableSamplingScope: [],
      tableSamplingScopeTotal: 0,
      tableSamplingScopeTotalPercent: 100,

      // Table valid speech
      headersValidSpeech,
      tableValidSpeech: [],
      tableValidSpeechTotal: 0,
      tableValidSpeechTotalPercent: 100,

      // Table qc persons
      headersQcPersons,
      tableQcPersons: [],
      tableQcPersonsTotal: 0,
      tableQcPersonsTotalPercent: 100
    }
  },
  watch: {
    count: {
      immediate: true,
      handler() {
        this.callData()
      }
    }
  },
  methods: {
    async callData() {
      try {
        this.loading = true

        await this.countQc()
        await this.getValidSpeech()
        await this.getSamplingScope()
        await this.getWordAccuracy()
        await this.getQcPersons()
        await this.getIntentAccuracy()

        this.loading = false
      } catch (error) {
      } finally {
        this.$emit('closeDialogLoading', null)
      }
    },
    async countQc() {
      try {
        const countQc = await apiInsight.countQc(this.search)

        const count = countQc.data.count ? countQc.data.count : 0

        this.$emit('checkTotalQc', count)
      } catch (error) {}
    },
    async getValidSpeech() {
      try {
        this.colorSpeech = []
        this.pieValidSpeech = []
        this.tableValidSpeech = []

        const getValidSpeech = await apiInsight.getValidSpeech(this.search)

        const { data: validSpeech } = getValidSpeech

        this.tableValidSpeechTotal = validSpeech.total ? validSpeech.total : 0

        let countColor = 0
        let percent = 0
        let obj = {}

        for (const [key, value] of Object.entries(validSpeech)) {
          if (key !== '_id' && key !== 'total') {
            percent =
              validSpeech.total !== 0
                ? (validSpeech[key] / validSpeech.total) * 100
                : 0

            obj = {
              name: key,
              value,
              percent
            }

            this.tableValidSpeech.push(obj)

            if (validSpeech[key] !== 0) {
              if (key === 'valid_speech') {
                this.pieValidSpeech.push(obj)
                this.colorSpeech.push(this.$getVoiceColor[0])
              } else {
                this.pieValidSpeech.push(obj)
                this.colorSpeech.push(this.$getGrayColor[countColor])
                countColor += 1
              }
            }
          }
        }
      } catch (error) {}
    },
    async getSamplingScope() {
      try {
        this.tableSamplingScope = []

        const getSamplingScope = await apiInsight.getSamplingScope(this.search)

        const { data: samplingScope } = getSamplingScope

        this.tableSamplingScopeTotal = samplingScope.total
          ? samplingScope.total
          : 0

        let percent = 0
        let obj = {}

        for (const [key, value] of Object.entries(samplingScope)) {
          if (key !== '_id' && key !== 'total') {
            percent =
              samplingScope.total !== 0
                ? (samplingScope[key] / samplingScope.total) * 100
                : 0

            obj = {
              name: key,
              value,
              percent
            }

            this.tableSamplingScope.push(obj)
          }
        }
      } catch (error) {}
    },
    async getWordAccuracy() {
      try {
        this.chartWordAccuracyXAxis1.data = []
        this.chartWordAccuracyData1.data = []
        this.chartWordAccuracyData2.data = []
        this.chartWordAccuracyData3.data = []

        this.tableWordAccuracy = []

        const getWordAccuracy = await apiInsight.getWordAccuracy(this.search)

        const { data } = getWordAccuracy

        const arr = []

        let total = 0
        let totalPercent = 0
        for (let i = 0; i < data.length; i++) {
          const { _id, word_acc, count } = data[i]

          const name = _id ? _id : '-'
          const percent = count !== 0 ? word_acc / count : 0

          arr.push({
            name,
            count,
            percent
          })

          // table
          this.tableWordAccuracy.push({
            name,
            value: count,
            percent
          })

          total += count
          totalPercent += word_acc
        }
        this.wordAccuracyTotal = total
        this.wordAccuracyTotalPercent = total !== 0 ? totalPercent / total : 0

        arr.sort(this.compare)

        const start = arr.length - 20 < 1 ? 0 : arr.length - 20
        for (let i = start; i < arr.length; i++) {
          const { name, count, percent } = arr[i]

          // chart
          this.chartWordAccuracyXAxis1.data.push(name)
          this.chartWordAccuracyData1.data.push(count)
          this.chartWordAccuracyData2.data.push(percent)
          this.chartWordAccuracyData3.data.push(this.wordAccuracyTotalPercent)
        }
      } catch (error) {}
    },
    async getQcPersons() {
      try {
        this.tableQcPersons = []

        const getQcPersons = await apiInsight.getQcPersons(this.search)

        const { data, total } = getQcPersons

        for (let i = 0; i < data.length; i++) {
          const { displayname, count } = data[i]

          let percent = total !== 0 ? (count / total) * 100 : 0

          const obj = {
            name: displayname ? displayname : '-',
            value: count,
            percent
          }

          this.tableQcPersons.push(obj)
        }

        this.tableQcPersonsTotal = total
      } catch (error) {}
    },
    async getIntentAccuracy() {
      try {
        this.chartIntentAccuracyXAxis1.data = []
        this.chartIntentAccuracyData1.data = []
        this.chartIntentAccuracyData2.data = []
        this.chartIntentAccuracyData3.data = []

        this.tableIntentAccuracy = []

        const getIntentAccuracy = await apiInsight.getIntentAccuracy(
          this.search
        )

        const { data } = getIntentAccuracy

        const arr = []

        let total = 0
        let totalOk = 0
        for (let i = 0; i < data.length; i++) {
          const { _id, ok, count } = data[i]

          const name = _id ? _id : '-'
          const percent = count !== 0 ? (ok * 100) / count : 0

          arr.push({
            name,
            count,
            percent
          })

          // Table
          this.tableIntentAccuracy.push({
            name,
            value: count,
            percent
          })

          total += count
          totalOk += ok
        }

        this.intentAccuracyTotal = total
        this.intentAccuracyTotalPercent =
          total !== 0 ? (totalOk * 100) / total : 0

        arr.sort(this.compare)

        const start = arr.length - 20 < 1 ? 0 : arr.length - 20
        for (let i = start; i < arr.length; i++) {
          const { name, count, percent } = arr[i]

          // chart
          this.chartIntentAccuracyXAxis1.data.push(name)
          this.chartIntentAccuracyData1.data.push(count)
          this.chartIntentAccuracyData2.data.push(percent)
          this.chartIntentAccuracyData3.data.push(
            this.intentAccuracyTotalPercent
          )
        }
      } catch (error) {}
    },

    compare(a, b) {
      if (a.count < b.count) {
        return -1
      }
      if (a.count > b.count) {
        return 1
      }
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  position: relative;
}

.overflow-y-scroll {
  overflow-y: scroll;
}
</style>
